import { Avatar, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconCustomerSupport } from './IconCustomerSupport';
import { DRAG_ID } from 'constants/common';

const CustomerSupport = ({ bottom = 30, right = 25 }) => {

    const { t } = useTranslation()

    const [openSupport, setOpenSupport] = useState(false)

    const handleOpenContactSupport = () => {
        setOpenSupport(prev => !prev)
    }

    return (
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'flex-end', gap: "10px", position: "fixed", width: 'fit-content', height: '50px', zIndex: '10000', bottom: bottom, right: right }}
            onClick={handleOpenContactSupport}
            onDragStart={(e) => e.dataTransfer.setData(DRAG_ID.ID, DRAG_ID.CUSTOMER_SUPPORT)}
            draggable>
            {openSupport &&
                <Typography sx={{ display: 'flex', alignItems: 'center', padding: '10px', backgroundColor: '#F2F2F2', borderRadius: '20px', width: "fit-content", height: '50px', fontWeight: '600' }}>{t('toast.contactSupport')}</Typography>
            }
            <Avatar
                variant="rounded"
                sx={{ cursor: "pointer", backgroundColor: "transparent", width: "50px", height: '50px' }}
            >
                <IconCustomerSupport />
            </Avatar>
        </div>
    )
}

export default CustomerSupport